<!-- Vuelidate v2 compatibility wrapper for InputDate
  Without this wrapper validation would trigger errors before blur/touch or submit
-->
<template>
  <InputWrap
    v-bind="$attrs"
    :label="label"
    :validations="validations"
    :wrap-label="wrapLabel"
    :validation-messages="validationMessages"
    :required="required"
    :info="info"
    :errors-ignore-vuelidate-dirty="true"
    v-slot="{ id, error, touch }"
  >
    <InputDate
      :id="id"
      :model-value="modelValue"
      :error="error"
      :disabled="disabled"
      @update:modelValue="$emit('update:modelValue', $event)"
      @blur="touch"
    />
  </InputWrap>
</template>

<script>
  import InputWrap from './InputWrap';
  import InputDate from './InputDate';

  /**
   * InputWrap + InputDate with Vuelidate error display that ignores spurious $dirty
   * from @vuepic/vue-datepicker (show errors after blur/touch or submit only).
   */
  export default {
    name: 'InputWrapDate',
    components: {
      InputWrap,
      InputDate,
    },
    inheritAttrs: false,
    props: {
      modelValue: {
        type: String,
        default: null,
      },
      validations: {
        type: Object,
        default: null,
      },
      label: {
        type: String,
        default: null,
      },
      wrapLabel: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      validationMessages: {
        type: Object,
        default: null,
      },
      required: {
        type: Boolean,
        default: null,
      },
      info: {
        type: String,
        default: null,
      },
    },
    emits: ['update:modelValue'],
  };
</script>
